export interface CatalogKeeper {
	KeeperId: number | null;
	KeeperCode: string;
	Description: string | null;
	IsActive: boolean;
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const CATALOG_KEEPER_INITIAL_VALUES: CatalogKeeper = {
	KeeperId: null,
	KeeperCode: "",
	Description: null,
	IsActive: true,
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
